/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment } from 'react'
import InputBox from '../../../CommonMethods/InputBox'
import ErrorMessage from '../../../components/ErrorMessage'
import TextArea from '../../../components/TextArea'
import Dropdown from '../../../components/Dropdown'
import { useState, useContext, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import GlobalContext from '../../../components/Context/GloablContext'
import AnimatedModel from '../../../components/Animation/AnimatedModel'
import moment from 'moment'
import Loader from '../../../components/Loader'
import ConfirmationPrompt from '../../../components/ConfirmationPrompt'
import CustomDatePicker from '../../../components/DatePicker'
import { useGetSubDivQuery, useUpdateEmailMutation } from '../../../slices/apiSlice'
import PhoneNumberValidator from '../../../components/PhoneNumberInput'
import { dataService } from '../../../services/data.services'
import SubdivisionDropdownWithSearch from './Components/subdivisionwithsearchwithoutcheckbox'
import TimeZoneDropdown from '../../../CommonMethods/TimeZoneDropdown'


export default function AddPatients({ edit, result, value,
    editPatient,
    validateEmail,
    addPatientDetails,
    selectedSubdivisionName,
    setisOpensub,
    isOpensub,
    selectedSubdivReadings,
    handleSelectionorgSubdivision,
    setAddPatientBasicDetails,
    setSelectedSubdivisionName,
    submitSelected,
    setSubmitSelected,
    emptyField,
    setEmptyField,
    setIsDisableCancel,
    isPhoneNumberValid,
    setIsPhoneNumberValid,
    caseManagersContactDetails,
    setcaseManagersContactDetails,
    emergencyContactDetails,
    setEmergencyContactDetails,
    emailError,
    setAdministrativeNotes,
    setMedicalNotes,
    setLoading,
    setEmailError,
    usernameError,
    setUsernameError,
    emptyArea,
    setEmptyArea,
    countryCodeVal,
    setCountryCodeVal,
    countryCodeVal2,
    setCountryCodeVal2,
    newCaseMangerCountycodes,
    setNewCaseMangerCountycodes,
    newCaseMangerValidCountrycode,
    setNewCaseMangerValidCountrycode,
    newEmergencyCountycodes,
    setNewEmergencyCountycodes,
    newEmergencyValidCountrycode,
    setNewEmergencyValidCountrycode,
    data,
    skip,
    setSkip,
    setIsRadioChecked,
    setIsAnyFieldFilled,
    loading ,
    isOpenTimeZone,
    setisOpenTimeZone,
    selectedTimeZone,
    setSelectedTimezone,
    handleSelectionTimezone,
    setSearchTimeZoneValue,
    searchTimeZoneValue,
    timezones,
    setTimezones,
    filteredTimezones,
    setFilteredTimezones
}) {


    const location = useLocation()
    // updtae email
    const [updateEmail] = useUpdateEmailMutation()

    const organization_id = sessionStorage.getItem('user_id')
    const [queryParams, setQueryParams] = useState(``, { refetchOnMountOrArgChange: true })
    let { data: suddivisonData, isFetching: sudDivisionIsFetching, isLoading, status: subdivisionStatus } = useGetSubDivQuery(queryParams)
    const [countryCodes, setCountryCodes] = useState([])
    const { id } = useParams()
    const [emailButtonLoading, setEmailButtonLoading] = useState(false)
    const [emailVefiedButton, setEmailVeriedButton] = useState(true);


    // const {data,isFetching,status}=useAddPatientMutation(id,{skip:skip})
    const [confirmationState, setConfirmationState] = useState(false)
    const [confirmationStateCancel, setConfirmationStateCancel] = useState(false)
    const [confirmationDeleteCaseManagerDetails, setConfirmationDeleteCaseManagerDetails] = useState(false)
    const [confirmationDeleteEmergencyDetails, setConfirmationDeleteEmergencyDetails] = useState(false)
    const [confirmationStateStatus, setConfirmationStateStatus] = useState(false)

    const [statusToggle, setStatusToggle] = useState(false)
    const [loadingStatus, setLoadingStatus] = useState(false)

    const { setToastmessage, setToastErrorMessage, isSideBar } = useContext(GlobalContext)


    const [deleteIndex, setDeleteIndex] = useState("")

    const [isOnType, setIsOnType] = useState(false)

    const navigate = useNavigate()
    const country_code = useSelector((state) => state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const dateformat = useSelector(state => state.systemConfigData.globalVariables.date_format)
    const [textAreaMsg, setTextAreaMsg] = useState('')



    const dispatch = useDispatch()

    useEffect(() => {
        setAddPatientBasicDetails((prev) => ({
            ...prev,
            country_code: `+ ${(country_code ? country_code.match(/\d+/)?.[0] || "" : "")}`
        }));
        fetchCountryCodes()
    }, [])

    // fetch country code
    const fetchCountryCodes = async () => {
        const res = await dataService?.getCountryCodes();
        // const extractedValues = res.data.map((country) => country.callingCodes[0]+'\t'+'-'+'\t'+'('+country.name+')');
        let uniqueValues = [...new Set(res?.data?.map((country) => country.callingCodes[0] + '\t' + '-' + '\t' + '(' + country.alpha3Code + ')'))];
        setCountryCodes(uniqueValues)
    }

    function calculateAge(inputDate) {
        // Parse the input date string
        const birthDate = new Date(inputDate);

        // Get the current date
        const currentDate = new Date();

        // Check if the birthday has occurred this year
        const hasBirthdayOccurred = (
            currentDate.getMonth() > birthDate.getMonth() ||
            (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() >= birthDate.getDate())
        );

        // Calculate the age in years
        const age = currentDate.getFullYear() - birthDate.getFullYear() - (hasBirthdayOccurred ? 0 : 1);

        return age;
    }



    function handleOnChangeUserDetails(id, option) {
        setIsAnyFieldFilled(true)
        setIsDisableCancel(false)
        setEmptyField(false);
        setSubmitSelected(false)
        setEmailError({
            email_error: false,
            username_error: false,
        });

        const fieldToUpdate = {
            user_name: "user_name",
            first_name: "first_name",
            middle_name: "middle_name",
            last_name: "last_name",
            email_addr: "email_addr",
            mobile_number: "mobile_number",
            main_number: "main_number",
            date_of_birth: "date_of_birth",
            age: "age",
            gender: "gender",
            address: "address",
            primary_identifier: "primary_identifier",
            secondary_identifier: "secondary_identifier",
            onboarding_date: "onboarding_date",
            weightKg: "weightKg",
            weightlbs: "weightlbs",
            // heightInch: "heightInch",
            // heightCm: "heightCm",
            patient_status: "patient_status",
            monitor_status: "monitor_status",
            number_of_readings: "number_of_readings",
            number_of_time_periods: "number_of_time_periods",
            time_period: "time_period"
        }[id];

        const regex = /^[1-9]\d*$/;
        const regexConversionWeight = /^\d{1,4}(\.\d{0,1})?$|^$/; // 4 integers and 1 decimal for weight
        const regexConversionHeight = /^\d{1,3}(\.\d{0,1})?$|^$/; // 3 integers and 1 decimal for height

        let sanitizedOption = option;
        let isValid = true;
        let conversionValid = true;

        if (id === "mobile_number" || id === "main_number" || id === "number_of_time_periods" || id === "number_of_readings") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid = false;

            }
        }

        // weight conversion
        let updatedWeightFields = {};

        if (id === "weightKg") {

            // Convert kg to lbs and update weightlbs field
            const lbsValue = convertKgToLbs(sanitizedOption);

            updatedWeightFields = {
                weightlbs: conversionValid && sanitizedOption === "" ? "" : !conversionValid && sanitizedOption === "" ? "" : lbsValue.toFixed(1),
            };
        } else if (id === "weightlbs") {
            // Convert lbs to kg and update weightKg field
            const kgValue = convertLbsToKg(sanitizedOption);
            updatedWeightFields = {
                weightKg: conversionValid && sanitizedOption === "" ? "" : !conversionValid && sanitizedOption === "" ? "" : kgValue.toFixed(1),
            };
        }

        // // height conversion
        // let updatedHeightFields = {};

        // if (id === "heightInch") {
        //     // Convert inches to cm and update heightCm field
        //     const cmValue = convertInchToCm(sanitizedOption);
        //     updatedHeightFields = {
        //         heightCm: conversionValid && sanitizedOption === "" ? "" : !conversionValid && sanitizedOption === "" ? "" : cmValue.toFixed(1),
        //     };
        // } else if (id === "heightCm") {
        //     // Convert cm to inches and update heightInch field
        //     const inchValue = convertCmToInch(sanitizedOption);
        //     updatedHeightFields = {
        //         heightInch: conversionValid && sanitizedOption === "" ? "" : !conversionValid && sanitizedOption === "" ? "" : inchValue.toFixed(1),
        //     };
        // }


        if (!isValid) {
            if (fieldToUpdate) {
                setAddPatientBasicDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption,
                    ...updatedWeightFields,
                    // ...updatedHeightFields,
                }));
            }
            return;
        }

        if (fieldToUpdate) {

            if (fieldToUpdate === "monitor_status") {
                setAddPatientBasicDetails((prev) => ({
                    ...prev,
                    "monitor_status": !addPatientDetails.monitor_status,
                }));
            }
            else if (fieldToUpdate === "mobile_number" || fieldToUpdate === "main_number") {
                if (option.length <= 20) {
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "first_name" || fieldToUpdate === "middle_name") {
                if (option.length <= 20) {
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));

                }

            }
            else if (fieldToUpdate === "last_name" || fieldToUpdate === "primary_identifier" || fieldToUpdate === "secondary_identifier") {
                if (option.length <= 30) {
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));

                }

            }
            else if (fieldToUpdate === "email_addr" || fieldToUpdate === "user_name") {
                setUsernameError(false)
                if (option.length <= 80) {
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option.replace(/\s/g, ''),
                    }));

                }
            }
            else if (fieldToUpdate === "date_of_birth") {

                setAddPatientBasicDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                    age: calculateAge(option)
                }));


            }
            else if (fieldToUpdate === "weightKg" || fieldToUpdate === "weightlbs") {
                if (regexConversionWeight.test(sanitizedOption)) {

                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: sanitizedOption,
                        ...updatedWeightFields,
                        // ...updatedHeightFields,
                    }));

                }
            }
            // else if (fieldToUpdate === "heightInch" || fieldToUpdate === "heightCm") {
            //     if (regexConversionHeight.test(sanitizedOption)) {

            //         setAddPatientBasicDetails((prev) => ({
            //             ...prev,
            //             [fieldToUpdate]: sanitizedOption,
            //             ...updatedWeightFields,
            //             ...updatedHeightFields,
            //         }));

            //     }
            // }
            else {

                setAddPatientBasicDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption,
                    ...updatedWeightFields,
                    // ...updatedHeightFields,
                }));

                // Check if the sanitizedOption is an empty string
                if (sanitizedOption === "") {
                    // Clear only the respective fields (height or weight)
                    setAddPatientBasicDetails((prev) => ({
                        ...prev,
                        [id]: "",
                    }));
                }


                setAddPatientBasicDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }


        }
    }
    const handleOnChangeCaseMangerContact = (id, option, index) => {
        setIsAnyFieldFilled(true)
        setEmptyField(false);
        setSubmitSelected(false)

        const fieldToUpdate = {
            case_manager_name: 'case_manager_name',
            mobile_number: 'mobile_number',
        }[id];

        if (fieldToUpdate) {
            setIsDisableCancel(false);

            const updatedCaseManagersContactDetails = [...caseManagersContactDetails];
            updatedCaseManagersContactDetails[index][fieldToUpdate] = option;

            setcaseManagersContactDetails(updatedCaseManagersContactDetails);
        }
    };
    const handleCOuntryCodeForObj = (index, item, id) => {
        setIsAnyFieldFilled(true)

        const updatedCOuntryCodes = [...newCaseMangerCountycodes];
        updatedCOuntryCodes[index][id] = item.split("-")[0].trim()
        setNewCaseMangerCountycodes(updatedCOuntryCodes)
    }

    const handlePhoneLayerValidation = (index, valid, id) => {

        const updatedIsValids = [...newCaseMangerValidCountrycode]
        updatedIsValids[index][id] = valid
        setNewCaseMangerValidCountrycode(updatedIsValids)

    }
    const handleEmergencyCOuntryCodeForObj = (index, item, id) => {
        setIsAnyFieldFilled(true)

        const updatedCOuntryCodes = [...newEmergencyCountycodes];
        updatedCOuntryCodes[index][id] = item.split("-")[0].trim()
        setNewEmergencyCountycodes(updatedCOuntryCodes)

    }

    const handleEmergencyPhoneLayerValidation = (index, valid, id) => {

        const updatedIsValids = [...newEmergencyValidCountrycode]
        updatedIsValids[index][id] = valid

        setNewEmergencyValidCountrycode(updatedIsValids)
    }

    const handleOnChangeEmergencyContactDetails = (id, option, index) => {
        setIsAnyFieldFilled(true)
        setEmptyField(false);
        setSubmitSelected(false)

        const fieldToUpdate = {
            emergency_contact_name: 'emergency_contact_name',
            mobile_number: 'mobile_number',
        }[id];

        if (fieldToUpdate) {
            setIsDisableCancel(false);

            const updatedEmergencyContactDetails = [...emergencyContactDetails];
            updatedEmergencyContactDetails[index][fieldToUpdate] = option;

            setEmergencyContactDetails(updatedEmergencyContactDetails);
        }
    };

    // Convert kilograms to pounds
    function convertKgToLbs(kg) {
        const poundsPerKg = 2.20462;

        return kg * poundsPerKg;
    }

    // Convert pounds to kilograms
    function convertLbsToKg(lbs) {
        const kgPerPound = 0.453592;
        return lbs * kgPerPound;
    }

    // // Convert inches to centimeters
    // function convertInchToCm(inch) {
    //     const cmPerInch = 2.54;
    //     return inch * cmPerInch;
    // }

    // // Convert centimeters to inches
    // function convertCmToInch(cm) {
    //     const inchPerCm = 0.393701;
    //     return cm * inchPerCm;
    // }

    function handleCheckBox(id, option) {
        setIsAnyFieldFilled(true)
        setAddPatientBasicDetails((prev) => ({
            ...prev,
            [id]: option,
        }));

    }
    const handleRemoveCaseContact = () => {
        setConfirmationDeleteCaseManagerDetails(true);
    };
    const handleEmeregencyContact = () => {
        setConfirmationDeleteEmergencyDetails(true)
    }

    const deleteContactDetails = () => {

        const updatedCaseManagerContactDetails = caseManagersContactDetails.filter((_, index) => index !== deleteIndex);
        const updatedCoun_fields = newCaseMangerCountycodes.filter((_, index) => index !== deleteIndex);
        const updatedPhoneValidations = newCaseMangerValidCountrycode.filter((_, index) => index !== deleteIndex);
        setNewCaseMangerValidCountrycode(updatedPhoneValidations);
        setNewCaseMangerCountycodes(updatedCoun_fields);
        setcaseManagersContactDetails(updatedCaseManagerContactDetails);
        setConfirmationDeleteCaseManagerDetails(false);
        setToastmessage('Case manager contact details deleted successfully')
    };

    const deleteEmergencyContactDetails = () => {

        const updatedEmergencyContactDetails = emergencyContactDetails.filter((_, index) => index !== deleteIndex);

        const updatedEmergencyCountry_fields = newEmergencyCountycodes.filter((_, index) => index !== deleteIndex);

        const updatedPhoneValidations = newEmergencyValidCountrycode.filter((_, index) => index !== deleteIndex);


        setNewEmergencyValidCountrycode(updatedPhoneValidations);
        setNewEmergencyCountycodes(updatedEmergencyCountry_fields);
        setEmergencyContactDetails(updatedEmergencyContactDetails);

        setConfirmationDeleteEmergencyDetails(false);
        setToastmessage('Emergecy contact details deleted successfully')
    };

    const handleAddCaseContact = () => {
        setIsAnyFieldFilled(true)
        setEmptyField(false);
        setToastErrorMessage('');

        // Create a new Case Manager detail object
        const newCaseManagerDetail = { case_manager_name: '', mobile_number: '' };

        // Create a new country code object for the new Case Manager detail
        const newCountryCode = { mobile_number: country_code?.split('\t').join('') };

        // Update state to include the new Case Manager detail and its corresponding country code
        setcaseManagersContactDetails((prevDetails) => [...prevDetails, newCaseManagerDetail]);

        setNewCaseMangerCountycodes((prevCodes) => [
            ...prevCodes,
            newCountryCode,
        ]);

        // Assuming you are updating some state related to phone number validation, update it accordingly
        setNewCaseMangerValidCountrycode((prevValidations) => [
            ...prevValidations,
            { mobile_number: true },
        ]);
    };
    const handleAddEmergencyContact = () => {
        setIsAnyFieldFilled(true)
        setEmptyField(false);
        setToastErrorMessage('');

        const newEmergencyContactDetail = { emergency_contact_name: '', mobile_number: '' };

        const newEmergencyCountryCode = { mobile_number: country_code?.split('\t').join('') };

        setEmergencyContactDetails((prevDetails) => [...prevDetails, newEmergencyContactDetail]);

        setNewEmergencyCountycodes((prevCodes) => [
            ...prevCodes,
            newEmergencyCountryCode,
        ]);

        setNewEmergencyValidCountrycode((prevValidations) => [
            ...prevValidations,
            { mobile_number: true },
        ]);
    };

    const handleMoveDown = (currentIndex) => {
        setIsOnType(false)
        const updatedContactDetails = [...caseManagersContactDetails];
        const updatedCounFields = [...newCaseMangerCountycodes];
        const updatedContryCodeValidity = [...newCaseMangerValidCountrycode]

        if (currentIndex < caseManagersContactDetails.length - 1) {
            // Swap current element with the next one
            [updatedContactDetails[currentIndex], updatedContactDetails[currentIndex + 1]] =
                [updatedContactDetails[currentIndex + 1], updatedContactDetails[currentIndex]];

            [updatedCounFields[currentIndex], updatedCounFields[currentIndex + 1]] =
                [updatedCounFields[currentIndex + 1], updatedCounFields[currentIndex]];

            [updatedContryCodeValidity[currentIndex], updatedContryCodeValidity[currentIndex + 1]] =
                [updatedContryCodeValidity[currentIndex + 1], updatedContryCodeValidity[currentIndex]]
            setcaseManagersContactDetails(updatedContactDetails);
            setNewCaseMangerCountycodes(updatedCounFields);
            setNewCaseMangerValidCountrycode(updatedContryCodeValidity)
        }
    };

    const handleMoveUp = (currentIndex) => {
        setIsOnType(false)
        const updatedContactDetails = [...caseManagersContactDetails];
        const updatedCounFields = [...newCaseMangerCountycodes];
        const updatedContryCodeValidity = [...newCaseMangerValidCountrycode]

        if (currentIndex > 0) {
            // Swap current element with the previous one
            [updatedContactDetails[currentIndex], updatedContactDetails[currentIndex - 1]] =
                [updatedContactDetails[currentIndex - 1], updatedContactDetails[currentIndex]];

            [updatedCounFields[currentIndex], updatedCounFields[currentIndex - 1]] =
                [updatedCounFields[currentIndex - 1], updatedCounFields[currentIndex]];

            [updatedContryCodeValidity[currentIndex], updatedContryCodeValidity[currentIndex - 1]] =
                [updatedContryCodeValidity[currentIndex - 1], updatedContryCodeValidity[currentIndex]]

            setcaseManagersContactDetails(updatedContactDetails);
            setNewCaseMangerCountycodes(updatedCounFields);
            setNewCaseMangerValidCountrycode(updatedContryCodeValidity)

        }
    };

    const handleMoveDownEmergencyContact = (currentIndex) => {
        setIsOnType(false)

        const updatedContactDetails = [...emergencyContactDetails];
        const updatedCounFields = [...newEmergencyCountycodes];
        const updatedContryCodeValidity = [...newEmergencyValidCountrycode]

        if (currentIndex < emergencyContactDetails.length - 1) {
            // Swap current element with the next one
            [updatedContactDetails[currentIndex], updatedContactDetails[currentIndex + 1]] =
                [updatedContactDetails[currentIndex + 1], updatedContactDetails[currentIndex]];

            [updatedCounFields[currentIndex], updatedCounFields[currentIndex + 1]] =
                [updatedCounFields[currentIndex + 1], updatedCounFields[currentIndex]];

            [updatedContryCodeValidity[currentIndex], updatedContryCodeValidity[currentIndex + 1]] =
                [updatedContryCodeValidity[currentIndex + 1], updatedContryCodeValidity[currentIndex]]

            setEmergencyContactDetails(updatedContactDetails);
            setNewEmergencyCountycodes(updatedCounFields);
            setNewEmergencyValidCountrycode(updatedContryCodeValidity)
        }
    };

    const handleMoveUpEmergencyContact = (currentIndex) => {
        setIsOnType(false)
        const updatedContactDetails = [...emergencyContactDetails];
        const updatedCounFields = [...newEmergencyCountycodes];
        const updatedContryCodeValidity = [...newEmergencyValidCountrycode]

        if (currentIndex > 0) {
            // Swap current element with the previous one
            [updatedContactDetails[currentIndex], updatedContactDetails[currentIndex - 1]] =
                [updatedContactDetails[currentIndex - 1], updatedContactDetails[currentIndex]];

            [updatedCounFields[currentIndex], updatedCounFields[currentIndex - 1]] =
                [updatedCounFields[currentIndex - 1], updatedCounFields[currentIndex]];

            [updatedContryCodeValidity[currentIndex], updatedContryCodeValidity[currentIndex - 1]] =
                [updatedContryCodeValidity[currentIndex - 1], updatedContryCodeValidity[currentIndex]]

            setEmergencyContactDetails(updatedContactDetails);
            setNewEmergencyCountycodes(updatedCounFields);
            setNewEmergencyValidCountrycode(updatedContryCodeValidity)

        }
    };

    const handleClearEmergencyContact = (index) => {
        const updatedEmergencyContactDetails = [...emergencyContactDetails];
        updatedEmergencyContactDetails[index].emergency_contact_name = ''; // or set to your desired empty value
        updatedEmergencyContactDetails[index].mobile_number = ''; // or set to your desired empty value

        // Update the state with the modified array
        setEmergencyContactDetails(updatedEmergencyContactDetails);
    };

    const handleClearCaseManagerContact = (index) => {
        const updatedCaseManagersContactDetails = [...caseManagersContactDetails];
        updatedCaseManagersContactDetails[index].case_manager_name = ''; // or set to your desired empty value
        updatedCaseManagersContactDetails[index].mobile_number = ''; // or set to your desired empty value

        // Update the state with the modified array
        setcaseManagersContactDetails(updatedCaseManagersContactDetails);
    };

    const handleConformationClick = () => {
        setEmptyArea(false)
        setConfirmationState(false);
    }
    const handleConformationClickCancel = () => {
        setEmptyArea(false)
        setConfirmationStateCancel(false);
    }
    const handelCloseDeleteModal = () => {
        setEmptyArea(false)
        setConfirmationDeleteCaseManagerDetails(false);
    }
    const handelCloseDeleteEmeregencyModal = () => {
        setEmptyArea(false)
        setConfirmationDeleteEmergencyDetails(false);
    }

    function handleSelectDate(id, date, dateString, termkey) {
        setIsAnyFieldFilled(true)
        if (id === "date_of_birth") {

            setAddPatientBasicDetails((prev) => ({
                ...prev,
                'date_of_birth': dateString,
                age: calculateAge(dateString), // Assuming calculateAge is a function that calculates age
            }));
        }
        else if (id === "onboarding_date") {
            setAddPatientBasicDetails((prev) => ({
                ...prev,
                'onboarding_date': dateString,
            }));
        }

    }

    const handleConformationClickStatus = () => {
        setEmptyArea(false)
        setStatusToggle(!statusToggle)
        setTextAreaMsg("")
        setConfirmationStateStatus(false);
    }

    const handleOnCLickChangeStatus = async (e) => {
        // useDispatch(handleIsAPICall(true))
        if (statusToggle === false && textAreaMsg.trim() === "") {
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyArea(true)
            return;
        }
        try {
            let body = {}
            if (statusToggle === false) {
                body = {
                    "user_names": [addPatientDetails.user_name],
                    "status": "inactive",
                    "note": textAreaMsg
                }
            }
            else {
                body = {
                    "user_names": [addPatientDetails.user_name],
                    "status": "active",
                    "note": ''
                }
            }

            setLoadingStatus(true)

            const activationRes = await editPatient({ body })

            setLoadingStatus(false)

            if (activationRes.error) {
                setToastErrorMessage('Something went wrong. Please try again')
            } else {
                setToastmessage(`Patient ${statusToggle === true ? "activated" : "deactivated"} successfully`);

            }
            setConfirmationStateStatus(false);
            setTextAreaMsg('');

        } catch (error) {
            setConfirmationStateStatus(false);
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }

    // verfiy email address
    const handleOnVerifyEmail = async () => {


        if (addPatientDetails?.email_addr?.trim() !== "" && validateEmail(addPatientDetails?.email_addr?.trim())) {
            setEmailError((prev) => ({
                ...prev,
                "email_error": true
            }))

            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return

        }
        try {
            setEmailButtonLoading(true)
            let response = null
            let body = {}
            body = {
                "user_type": "patient",
                "email_address": addPatientDetails.email_addr.trim().replace(/\s/g, ''),
            }
            const emailVerifyRes = await updateEmail({ id, body })

            if (emailVerifyRes?.error?.data?.message === "Email Address must be a valid email address") {
                setEmailError((prev) => ({
                    ...prev,
                    "email_error": true
                }))
                setEmailButtonLoading(false)
            }
            else if (emailVerifyRes?.error?.data?.message) {
                setConfirmationState(false)
                setToastErrorMessage(emailVerifyRes?.error?.data?.message)
                setEmailButtonLoading(false)
            }
            else {
                setToastmessage(emailVerifyRes?.data?.message);
                setEmailButtonLoading(false)
                setEmailVeriedButton(false)
            }
            setIsDisableCancel(true)
        } catch (error) {
            setLoading(false);
            setToastErrorMessage(error.message)
        }

    }


    // handle subdivision list
    useEffect(() => {
        if (edit) {
            setSkip(false)
        }
    }, [edit])

    useEffect(() => {
        if (data !== undefined) {
            // setMonitorUserId(data?.user_id)

            setStatusToggle(data[0]?.status === "inactive" ? false : true)


            setSkip(true)
        }


        if (data && edit) {
            const administrativeNotes = data[0]?.notes || []; // Ensure notes array exists
            const notes = administrativeNotes
                ?.filter(item => item.note_type === "administrative-note") // Filter out only administrative notes
                ?.map(item => ({
                    administrative_Notes: item.description || '',
                    first_name: item.first_name || '',
                    last_name: item.last_name || '',
                    user_type: item.user_type || '',
                    created_date: item.timestamp || '',
                    patient_id: item.patient_id || '',
                }));

            setAdministrativeNotes(notes);
        }

        if (data && edit) {
            const medicalNotes = data[0]?.notes || []; // Ensure notes array exists
            const medicalnote = medicalNotes
                ?.filter(item => item.note_type === "medical-note") // Filter out only administrative notes
                ?.map(item => ({
                    medical_Notes: item.description || '',
                    first_name: item.first_name || '',
                    last_name: item.last_name || '',
                    user_type: item.user_type || '',
                    created_date: item.timestamp || '',
                }));

            setMedicalNotes(medicalnote);
        }

        if (data && edit) {
            setCountryCodeVal(data[0]?.country_code1?.split('+')[1])
            setCountryCodeVal2(data[0]?.country_code2?.split('+')[1])
            const caseManagerDetails = data[0]?.case_managers?.length > 0 ? data[0]?.case_managers : [{}];
            setcaseManagersContactDetails(
                caseManagerDetails?.map((manager) => ({
                    case_manager_name: manager.name || '',
                    mobile_number: manager.contact_number || '',
                }))
            );
            setNewCaseMangerCountycodes(
                caseManagerDetails?.map((manager) => ({
                    mobile_number: manager.country_code?.replace('+', '')?.split('\t').join('') || '',
                }))
            );
            setNewCaseMangerValidCountrycode(
                caseManagerDetails?.map(() => ({
                    mobile_number: true,
                }))
            );

            const emergencyContactDetailsres = data[0]?.contacts?.length > 0 ? data[0]?.contacts : [{}];
            setEmergencyContactDetails(
                emergencyContactDetailsres?.map((contact) => ({
                    emergency_contact_name: contact.name || '',
                    mobile_number: contact.contact_number || '',
                }))
            );
            setNewEmergencyCountycodes(
                emergencyContactDetailsres?.map((contact) => ({
                    mobile_number: contact.country_code?.replace('+', '')?.split('\t').join('') || '',
                }))
            );
            setNewEmergencyValidCountrycode(
                emergencyContactDetailsres?.map(() => ({
                    mobile_number: true,
                }))
            );
        }
    }, [data])


    const redioButtonGender = ["Male", "Female", "Other"]
    const date = dateformat?.includes('AM/PM') ? moment(data?.created_at + 'Z')?.utcOffset('+05:30')?.format(`${dateformat.split(',')[0]} h:mm:ss A`) : moment(data?.created_at).format(dateformat)

    return (
        <>
            <div>
                <div className='mb-6'>
                    <h1 className='border-b border-[#000000] pb-2 text-[18px] font-normal text-[#000000] relative basic_details_heading_dot mb-5'>Basic Details</h1>
                    <div className='flex flex-wrap -mx-3'>
                        {edit && <div className={`w-1/3 px-3 mb-[22px]`}>
                            <div className='w-full'>
                                <InputBox
                                    label={"Username*"}
                                    placeholder={"Enter username"}
                                    id={"user_name"}
                                    htmlFor={"Admin_Username"}
                                    value={addPatientDetails?.user_name}
                                    emailError={emailError.username_error}
                                    usernameError={usernameError}
                                    emptyField={emptyField && addPatientDetails?.user_name?.trim() === ""}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    disabled={true}
                                />
                                {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '} message={"Invalid user name"} />}
                            </div>
                        </div>}
                        {!edit &&
                            <div className={`w-1/3 px-3 mb-[22px]`}>
                                <div className='w-full'>
                                    <InputBox
                                        label={"Username*"}
                                        placeholder={"Enter username"}
                                        id={"user_name"}
                                        maxLength={80}
                                        data-testid={"username"}
                                        htmlFor={"user_name"}
                                        value={addPatientDetails.user_name}
                                        emailError={emailError.username_error}
                                        usernameError={usernameError}
                                        emptyField={emptyField && addPatientDetails?.user_name?.trim() === ""}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                    />
                                    {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '} message={"Invalid user name"} />}
                                </div>
                            </div>
                        }
                    </div>
                    <div className='flex flex-wrap -mx-3'>
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='w-full'>
                                <InputBox
                                    label={"First Name*"}
                                    placeholder={"Enter first name"}
                                    id={"first_name"}
                                    data-testid={"first_name"}
                                    htmlFor={"first_name"}
                                    value={addPatientDetails.first_name}
                                    emptyField={emptyField && addPatientDetails?.first_name?.trim() === ""}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                />
                            </div>
                        </div>
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='w-full'>
                                <InputBox
                                    label={"Middle Name"}
                                    placeholder={"Enter middle name"}
                                    id={"middle_name"}
                                    htmlFor={"middle_name"}
                                    value={addPatientDetails.middle_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                />
                            </div>
                        </div>
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='w-full'>
                                <InputBox
                                    label={"Last Name*"}
                                    placeholder={"Enter last name"}
                                    id={"last_name"}
                                    data-testid={"last_name"}
                                    htmlFor={"last_name"}
                                    value={addPatientDetails.last_name}
                                    emptyField={emptyField && addPatientDetails?.last_name?.trim() === ""}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                />
                            </div>
                        </div>
                        {!edit && <div className={`w-1/3 px-3 mb-[22px]`}>
                            <div className='w-full'>
                                <InputBox
                                    label={"Email Address*"}
                                    placeholder={"Enter email address"}
                                    id={"email_addr"}
                                    data-testid={"email_address"}
                                    htmlFor={"email_addr"}
                                    value={addPatientDetails.user_name}
                                    disabled={true}
                                    emptyField={emptyField && addPatientDetails?.user_name?.trim() === ""}
                                    emailError={emailError.email_error}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                />
                                {emailError.email_error && <ErrorMessage error message={"Invalid email address"} />}
                            </div>
                        </div>}

                        {edit &&
                            <div className={`w-full flex px-3 mb-[22px]`}>
                                <div className='w-1/3'>
                                    <InputBox
                                        label={"Email Address*"}
                                        placeholder={"Enter email address"}
                                        id={"email_addr"}
                                        data-testid={"email_address"}
                                        htmlFor={"email_addr"}
                                        value={addPatientDetails.email_addr}
                                        emptyField={emptyField && addPatientDetails?.email_addr?.trim() === ""}
                                        emailError={emailError.email_error}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                    />
                                    {emailError.email_error && <ErrorMessage error message={"Invalid email address"} />}
                                </div>
                                {(Array.isArray(data) && data.length > 0) && (data[0].email_address !== addPatientDetails?.email_addr) && (
                                    <div className={`w-2/3 px-[18px] mb-[35px] pt-3.5`}>
                                        <button
                                            type='button'
                                            id="verify"
                                            onClick={() => handleOnVerifyEmail()}
                                            disabled={emailButtonLoading || addPatientDetails?.email_addr?.trim() === ""}
                                            className={`px-4 py-2 text-lg flex items-center justify-center font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[170px]
                        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] disabled:cursor-not-allowed`}
                                        >
                                            {!emailButtonLoading ? "Verify" : <span>{<Loader />}</span>}
                                        </button>
                                    </div>
                                )}

                                {(Array.isArray(data) && data.length > 0) && (data[0].email_address === addPatientDetails?.email_addr) &&
                                    <div className={`w-2/3 px-[18px] mb-[35px] pt-3`}>
                                        <button type='button'
                                            id="verified"
                                            className={`px-4 py-2 flex items-center justify-center text-lg font-semibold text-[#000] rounded-[16px] mt-2.5 w-[170px] cursor-default
                                                            bg-[#C5C9DA] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                            <span className='w-6 h-6 bg-[#1A883C] rounded-[50%] mr-2.5 flex justify-center items-center'>
                                                <img src="/images/success_toast.svg" alt="icon" loading='lazy' className='w-3.5 h-3.5' decoding='async' />
                                            </span>
                                            Verified
                                        </button>
                                    </div>
                                }
                            </div>
                        }
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='w-full'>

                                <PhoneNumberValidator
                                    label={"Mobile Number"}
                                    placeholder={"Enter mobile number"}
                                    id={"mobile_number"}
                                    htmlFor={"mobile_number"}
                                    value={addPatientDetails.mobile_number}
                                    emptyField={false}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    isCode={true}
                                    countryCodeList={countryCodes}
                                    country_code={country_code}
                                    countryCodeVal={countryCodeVal2}
                                    isPhoneNumberValid={isPhoneNumberValid?.mobile_number}
                                    setIsPhoneNumberValid={setIsPhoneNumberValid}
                                    setCountryCodeVal={setCountryCodeVal2}
                                    submitSelected={submitSelected}
                                //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                />
                            </div>
                        </div>
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='w-full'>
                                <PhoneNumberValidator
                                    label={"Main Number*"}
                                    placeholder={"Enter main number"}
                                    id={"main_number"}
                                    htmlFor={"main_number"}
                                    value={addPatientDetails.main_number}
                                    emptyField={emptyField && addPatientDetails?.main_number?.trim() === ""}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    isCode={true}
                                    countryCodeList={countryCodes}
                                    country_code={country_code}
                                    countryCodeVal={countryCodeVal}
                                    setCountryCodeVal={setCountryCodeVal}
                                    isPhoneNumberValid={isPhoneNumberValid?.main_number}
                                    setIsPhoneNumberValid={setIsPhoneNumberValid}
                                    submitSelected={submitSelected}
                                //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                />
                            </div>
                        </div>
                        {edit && <div className='w-1/3 px-[18px] mt-[37px] mb-[35px]'>
                            <div className='w-full'>
                                <div className="status custom-toggle flex items-center ">
                                    <p className="text-sm font-normal  text-[#000000] disable_switch  mr-4">
                                        Status
                                    </p>
                                    <label className="switch" style={{ marginLeft: '10px' }}>
                                        <input type="checkbox" id="user_status" onChange={(e) => {
                                            setStatusToggle(!statusToggle), setConfirmationStateStatus(true)
                                        }} checked={statusToggle} /><span className="slider round"></span>
                                    </label>
                                    <p id='status' className="text-sm font-normal  text-[#008586] disable_switch ml-3">
                                        {statusToggle ? 'Active' : 'Inactive'}
                                    </p>
                                </div>
                            </div>
                        </div>}

                        <div className='w-1/3 px-3 mt-2.5 mb-[22px]'>
                            <div className='flex -mx-3'>
                                <div className='w-2/3 px-3'>
                                    <div className='w-full'>
                                        <CustomDatePicker
                                            id={"date_of_birth"}
                                            classKey={`border ${emptyField && addPatientDetails?.date_of_birth === "" ? 'border-red-500' : 'border-[#C5C9DA] '} rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                                            format="MMM DD, YYYY"
                                            // state={filterValues}
                                            placeholder={"Select date"}
                                            label={"Date of Birth*"}
                                            termkey={addPatientDetails?.date_of_birth}
                                            handleSelect={handleSelectDate}
                                            disabledFutureDate={true}

                                        />
                                    </div>
                                </div>
                                <div className='w-1/3 px-3'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Age"}
                                            placeholder={"Age"}
                                            id={"age"}
                                            htmlFor={"age"}
                                            value={addPatientDetails.age}
                                            disabled={true}
                                            handleOnChangeInput={handleSelectDate}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='w-1/3 px-3 mb-[22px] mt-2.5'>
                            {/* gender */}
                            <div className='w-full'>
                                <p className='text-[12px] font-semibold text-[#000000] pb-1.5'>Gender*</p>
                                <div className='flex items-center'>
                                    {redioButtonGender?.map((item) =>
                                        (<div className="p-2" key={item}>
                                            <div className="relative custom-radioBlue flex items-center">
                                                <input id={item} data_testid={"gender"} type="radio" name="default-radio" checked={addPatientDetails?.gender === item} onChange={() => { handleCheckBox("gender", item) }} />
                                                <label htmlFor={item} className="text-base font-normal text-[#000] pl-8 w-full cursor-pointer">
                                                    {item}
                                                </label>
                                            </div>
                                        </div>))}
                                </div>
                            </div>
                        </div>
                        
                        <div className='w-full px-3 mb-[35px]'>
                            <div className='w-3/4'>
                                <TextArea label={'Address'}
                                    htmlFor={'address'}
                                    id={'address'}
                                    value={addPatientDetails?.address}
                                    placeholder={'Enter Address'}
                                    emptyField={false}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                />
                            </div>
                        </div>
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='w-full'>
                                <InputBox
                                    label={"Primary Identifier*"}
                                    placeholder={"Enter primary identifier"}
                                    id={"primary_identifier"}
                                    htmlFor={"primary_identifier"}
                                    value={addPatientDetails.primary_identifier}
                                    emptyField={emptyField && addPatientDetails?.primary_identifier?.trim() === ""}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                />
                            </div>
                        </div>
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='w-full'>
                                <InputBox
                                    label={"Secondary Identifier"}
                                    placeholder={"Enter secondary identifier "}
                                    id={"secondary_identifier"}
                                    htmlFor={"secondary_identifier"}
                                    value={addPatientDetails.secondary_identifier}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                />
                            </div>
                        </div>
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='xl:w-[80%] w-full'>
                                <CustomDatePicker
                                    id={"onboarding_date"}
                                    classKey={`border border-[#C5C9DA] rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                                    format="MMM DD, YYYY"
                                    // state={filterValues}
                                    placeholder={"Select Date"}
                                    label={"Onboarding Date"}
                                    termkey={addPatientDetails?.onboarding_date}
                                    handleSelect={handleSelectDate}

                                />
                            </div>
                        </div>
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='flex -mx-3'>
                                <div className='px-3 w-1/2'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Weight(kg)*"}
                                            placeholder={"Enter weight"}
                                            id={"weightKg"}
                                            data-testid={"weight_in_kg"}
                                            htmlFor={"weightKg"}
                                            value={addPatientDetails.weightKg}
                                            emptyField={emptyField && addPatientDetails?.weightKg === ""}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                    </div>
                                </div>
                                <div className='px-3 w-1/2'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Weight(lbs)*"}
                                            placeholder={"Enter weight"}
                                            id={"weightlbs"}
                                            htmlFor={"weightlbs"}
                                            value={addPatientDetails.weightlbs}
                                            emptyField={emptyField && addPatientDetails?.weightlbs === ""}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='flex -mx-3'>
                                <div className='px-3 w-1/2'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Height(inch)*"}
                                            placeholder={"Enter height"}
                                            id={"heightInch"}
                                            data-testid={"height_in_inch"}
                                            htmlFor={"heightInch"}
                                            value={addPatientDetails.heightInch}
                                            emptyField={emptyField && addPatientDetails?.heightInch === ""}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                    </div>
                                </div>
                                <div className='px-3 w-1/2'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Height(cm)*"}
                                            placeholder={"Enter height"}
                                            id={"heightCm"}
                                            htmlFor={"heightCm"}
                                            value={addPatientDetails?.heightCm}
                                            emptyField={emptyField && addPatientDetails?.heightCm === ""}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='w-full'>
                                <Dropdown
                                    label={"Patient Status*"}
                                    id={"patient_status"}
                                    placeholder={
                                        (addPatientDetails.patient_status && addPatientDetails.patient_status.length > 0)
                                            ? ''
                                            : 'Select patient status'
                                    }
                                    data_testid={"patient_status"}
                                    value={addPatientDetails?.patient_status}
                                    options={['At Home', 'Hospitalized', 'Away', 'Deceased']}
                                    emptyField={emptyField && addPatientDetails.patient_status.length === 0}
                                    handleOnChangeInput={handleOnChangeUserDetails} />
                            </div>
                        </div>
                        <div className='w-1/3 px-3 mb-[22px]'>
                            <div className='w-full'>
                                <TimeZoneDropdown
                                    label={`Time Zone*`}
                                    placeholder={'Select patient time zone'}
                                    id={'patient_timezone'}
                                    disabled={false}
                                    selectedTimezone={selectedTimeZone}
                                    setisOpenTimeZone={setisOpenTimeZone}
                                    isOpenTimeZone={isOpenTimeZone}
                                    handleSelectionTimezone={handleSelectionTimezone}
                                    setSelectedTimezone={setSelectedTimezone}
                                    setSearchValue={setSearchTimeZoneValue}
                                    searchValue={searchTimeZoneValue}
                                    emptyField={emptyField && selectedTimeZone.length === 0}
                                    timezones={timezones}
                                    setTimezones={setTimezones}
                                    filteredTimezones={filteredTimezones}
                                    setFilteredTimezones={setFilteredTimezones}
                                />
                            </div>

                        </div>
                        <div className={`w-full px-3 mb-[22px]`}>
                            <div className='w-full'>
                                <p className='text-sm font-semibold text-[#000000] mb-1.5'>Monitoring Status*</p>
                                <div className='flex items-center'>
                                    <div className="p-2">
                                        <div className="relative custom-radioBlue flex items-center">
                                            <input id="monitored" type="radio" name="default-radio1" checked={addPatientDetails?.monitor_status} onChange={() => handleOnChangeUserDetails("monitor_status", false)} />
                                            <label htmlFor="monitored" className={`text-base font-normal ${addPatientDetails?.monitor_status ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                Monitored
                                            </label>
                                        </div>
                                    </div>
                                    <div className="p-2">
                                        <div className="relative custom-radioBlue flex items-center" >
                                            <input id="not_monitored" type="radio" name="default-radio1" checked={!addPatientDetails?.monitor_status} onChange={() => handleOnChangeUserDetails("monitor_status", true)} />
                                            <label htmlFor="not_monitored" className={`text-base font-normal ${!addPatientDetails?.monitor_status ? 'text-[#000]' : 'text-[#52555D]'} pl-8 w-full cursor-pointer`}>
                                                Not Monitored
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {/* <h1 className='border-b border-[#000000] pb-2 text-[18px] font-normal text-[#000000] relative basic_details_heading_dot mb-2.5'>Minimun Readings Conditions(By default 4 readings in 30 days)</h1> */}
                    <h1 className='border-b border-[#000000] pb-2 text-[18px] font-normal text-[#000000] relative basic_details_heading_dot mb-2.5'>{`Minimun Readings Conditions (By default ${selectedSubdivReadings?.number_of_readings} readings in ${selectedSubdivReadings?.number_of_time_periods} ${selectedSubdivReadings?.time_period})`}</h1>
                    <div className='bg-[#CCE7E7]'>
                        <div className='flex p-5'>
                            <div className='w-1/4 mr-[24px]'>
                                <InputBox
                                    label={"Readings*"}
                                    maxLength={3}
                                    id={"number_of_readings"}
                                    htmlFor={"number_of_readings"}
                                    placeholder={'Enter number of readings'}
                                    value={(addPatientDetails.number_of_readings === null || addPatientDetails.number_of_readings === "") ? "" : addPatientDetails.number_of_readings}
                                    // value={addPatientDetails.number_of_readings === null ? '' :addPatientDetails.number_of_readings}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    emptyField={emptyField && addPatientDetails.number_of_readings === "" || addPatientDetails.number_of_readings === null}
                                />

                            </div>
                            <div className='w-1/4 mr-[24px]'>
                                <InputBox
                                    label={"Number of Days*"}
                                    maxLength={3}
                                    id={"number_of_time_periods"}
                                    htmlFor={"number_of_time_periods"}
                                    placeholder={"Enter number of days"}
                                    // value={addPatientDetails.number_of_time_periods === null ? '' : addPatientDetails.number_of_time_periods || '30'}
                                    value={(addPatientDetails.number_of_time_periods === null || addPatientDetails.number_of_time_periods === "") ? "" : addPatientDetails.number_of_time_periods}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    emptyField={emptyField && addPatientDetails.number_of_time_periods === "" || addPatientDetails.number_of_time_periods === null}

                                />
                            </div>
                            <div className='w-1/4'>
                                <Dropdown
                                    label={"Time Period*"}
                                    id={"time_period"}
                                    placeholder={''}
                                    // value={addPatientDetails.time_period||'Day(s)'}
                                    value={addPatientDetails.time_period || 'Day(s)'}
                                    options={['Day(s)', 'Week(s)', 'Month(s)', 'Calendar Month(s)']}
                                    emptyField={emptyField && addPatientDetails.time_period.length === 0}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='mb-5 mt-8'>
                    <h1 className='border-b border-[#000000] pb-2 text-[18px] font-normal text-[#000000] relative basic_details_heading_dot mb-2.5'>Additional Contact Details</h1>
                    <div>
                        <h1 className='pb-3 text-base font-normal text-[#000000] w-fit pt-6 relative border_bottom_sideRounded mb-3'>Emergency Contact Details (First entry is highest priority)</h1>
                        {emergencyContactDetails?.map((field, index) => (<Fragment key={index}>
                            <div id='contact_details' className='flex -mx-3 mb-[32px]'>
                                <div className='w-1/6 px-3 pt-[22px]'>
                                    <div className='w-full rounded-lg border border-[#C5C9DA] flex'>
                                        <button
                                            className='disabled:opacity-50 w-1/2 pl-2 py-[10px]'
                                            onClick={() => handleMoveDownEmergencyContact(index)}
                                            disabled={index === emergencyContactDetails.length - 1}

                                        >
                                            <img src="/images/arrow-down.svg" alt="icon" className='mx-auto' />
                                        </button>


                                        <button
                                            className='disabled:opacity-50 w-1/2 pr-2 py-[10px]'
                                            onClick={() => handleMoveUpEmergencyContact(index)}
                                            disabled={index === 0}
                                        >
                                            <img src="/images/arrow-down.svg" alt="icon" className='rotate-[180deg] mx-auto' />
                                        </button>

                                    </div>
                                </div>
                                <div className='w-2/6 px-3'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Name"}
                                            maxLength={60}
                                            placeholder={"Enter name"}
                                            id={"emergency_contact_name"}
                                            htmlFor={"emergency_contact_name"}
                                            value={emergencyContactDetails[index].emergency_contact_name}
                                            handleOnChangeInput={handleOnChangeEmergencyContactDetails}
                                            index={index}
                                        />
                                    </div>

                                </div>
                                <div className='w-2/6 px-3'>
                                    <div className='w-full'>

                                        <PhoneNumberValidator
                                            label={"Mobile Number"}
                                            placeholder={"Enter mobile number"}
                                            id={"mobile_number"}
                                            data_testid="emergencyContact_mobile_number"
                                            htmlFor={"Admin_Mobile_Number"}
                                            value={emergencyContactDetails[index]?.mobile_number}
                                            emptyField={false}
                                            handleOnChangeInput={handleOnChangeEmergencyContactDetails}
                                            handleCOuntryCodeForObj={handleEmergencyCOuntryCodeForObj}
                                            isCode={true}
                                            index={index}
                                            countryCodeList={countryCodes}
                                            country_code={country_code}
                                            countryCodeVal={newEmergencyCountycodes[index]?.mobile_number}
                                            isPhoneNumberValid={newEmergencyValidCountrycode[index]?.mobile_number}
                                            setIsPhoneNumberValid={handleEmergencyPhoneLayerValidation}
                                            setCountryCodeVal={setNewEmergencyCountycodes}
                                            submitSelected={submitSelected}
                                            isOnType={isOnType}
                                            maxLength={20}
                                            setIsOnType={setIsOnType}
                                        //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                        />
                                    </div>

                                </div>
                                <div className='w-1/6 px-[18px] flex'>
                                    {emergencyContactDetails?.length === 1 && (
                                        <div className='flex'>
                                            <div className="relative pt-[34px]">
                                                <button className='clear_contact'
                                                    onClick={() => handleClearEmergencyContact(index)}
                                                >
                                                    <span>
                                                        <img
                                                            loading='lazy'
                                                            decoding='async'
                                                            src="/images/red-x-line-icon.svg"
                                                            alt="clear-icon"
                                                            className='w-[27px]'
                                                        />
                                                    </span>
                                                </button>
                                                <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-9px] clear_contact_text opacity-0'>
                                                    Clear
                                                </p>
                                            </div>
                                            <div className='relative ml-4'>
                                                <button onClick={handleAddEmergencyContact} type='button' className='pt-[37px] add_contact'>
                                                    <span>
                                                        <img
                                                            loading='lazy'
                                                            decoding='async'
                                                            src="/images/add-plus-red.svg"
                                                            alt="add-icon"
                                                            id='add_more'
                                                        />
                                                    </span>
                                                </button>
                                                <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_contact_text opacity-0'>
                                                    Add
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                    {emergencyContactDetails?.length > 1 && (
                                        <>
                                            {index === 0 && (
                                                <div className="relative">
                                                    <button
                                                        onClick={() => {
                                                            setDeleteIndex(index);
                                                            handleEmeregencyContact();
                                                        }}
                                                        className='pt-9 delete_contact'
                                                    >
                                                        <span>
                                                            <img
                                                                loading='lazy'
                                                                decoding='async'
                                                                src="/images/deleteicon-pink.svg"
                                                                alt="delete-icon"
                                                            />
                                                        </span>
                                                    </button>
                                                    <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                        Delete
                                                    </p>
                                                </div>
                                            )}
                                            {index !== 0 && index !== emergencyContactDetails?.length - 1 && (
                                                <div className="relative">
                                                    <button
                                                        onClick={() => {
                                                            setDeleteIndex(index);
                                                            handleEmeregencyContact();
                                                        }}
                                                        className='pt-9 delete_contact'
                                                    >
                                                        <span>
                                                            <img
                                                                loading='lazy'
                                                                decoding='async'
                                                                id='delete_contact'
                                                                src="/images/deleteicon-pink.svg"
                                                                alt="delete-icon"
                                                            />
                                                        </span>
                                                    </button>
                                                    <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                        Delete
                                                    </p>
                                                </div>
                                            )}
                                            {index === emergencyContactDetails?.length - 1 && (
                                                <div className='flex'>
                                                    <div className='relative'>
                                                        <button onClick={() => { setDeleteIndex(index); handleEmeregencyContact() }} className='pt-9 delete_contact'>
                                                            <span>
                                                                <img
                                                                    loading='lazy'
                                                                    decoding='async'
                                                                    id='delete_contact'
                                                                    src="/images/deleteicon-pink.svg"
                                                                    alt="delete-icon"
                                                                />
                                                            </span>
                                                        </button>
                                                        <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                            Delete
                                                        </p>
                                                    </div>
                                                    <div className='relative ml-4'>
                                                        <button onClick={handleAddEmergencyContact} type='button' className='pt-[37px] add_contact'>
                                                            <span>
                                                                <img
                                                                    loading='lazy'
                                                                    decoding='async'
                                                                    src="/images/add-plus-red.svg"
                                                                    alt="add-icon"
                                                                    id='add_more'
                                                                />
                                                            </span>
                                                        </button>
                                                        <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_contact_text opacity-0'>
                                                            Add
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </Fragment>))}
                    </div>
                    <div>
                        <h1 className='pb-3 text-base font-normal text-[#000000] w-fit pt-6 relative border_bottom_sideRounded mb-3'>Case Manager Contact Details (First entry is highest priority)</h1>
                        {caseManagersContactDetails?.map((field, index) => (<Fragment key={index}>
                            <div className='flex -mx-3 mb-[32px]'>
                                <div className='w-1/6 px-3 pt-[22px]'>
                                    <div className='w-full rounded-lg border border-[#C5C9DA] flex'>
                                        <button
                                            className='disabled:opacity-50 w-1/2 pl-2 py-[10px]'
                                            onClick={() => handleMoveDown(index)}
                                            disabled={index === caseManagersContactDetails.length - 1}

                                        >
                                            <img src="/images/arrow-down.svg" alt="icon" className='mx-auto' />
                                        </button>


                                        <button
                                            className='disabled:opacity-50 w-1/2 pr-2 py-[10px]'
                                            onClick={() => handleMoveUp(index)}
                                            disabled={index === 0}
                                        >
                                            <img src="/images/arrow-down.svg" alt="icon" className='rotate-[180deg] mx-auto' />
                                        </button>

                                    </div>
                                </div>
                                <div className='w-2/6 px-3'>
                                    <div className='w-full'>
                                        <InputBox
                                            label={"Name"}
                                            maxLength={60}
                                            placeholder={"Enter name"}
                                            id={"case_manager_name"}
                                            htmlFor={"case_manager_name"}
                                            value={caseManagersContactDetails[index].case_manager_name}
                                            handleOnChangeInput={handleOnChangeCaseMangerContact}
                                            index={index}
                                        />
                                    </div>

                                </div>
                                <div className='w-2/6 px-3'>
                                    <div className='w-full'>

                                        <PhoneNumberValidator
                                            label={"Mobile Number"}
                                            placeholder={"Enter mobile number"}
                                            id={"mobile_number"}
                                            data_testid="caseManager_mobile_number"
                                            htmlFor={"Admin_Mobile_Number"}
                                            value={caseManagersContactDetails[index]?.mobile_number}
                                            emptyField={false}
                                            handleOnChangeInput={handleOnChangeCaseMangerContact}
                                            handleCOuntryCodeForObj={handleCOuntryCodeForObj}
                                            isCode={true}
                                            index={index}
                                            countryCodeList={countryCodes}
                                            country_code={country_code}
                                            countryCodeVal={newCaseMangerCountycodes[index]?.mobile_number}
                                            isPhoneNumberValid={newCaseMangerValidCountrycode[index]?.mobile_number}
                                            setIsPhoneNumberValid={handlePhoneLayerValidation}
                                            setCountryCodeVal={setNewCaseMangerCountycodes}
                                            submitSelected={submitSelected}
                                            isOnType={isOnType}
                                            setIsOnType={setIsOnType}
                                            maxLength={20}
                                        //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                        />
                                    </div>

                                </div>
                                <div className='w-1/6 px-[18px] flex'>
                                    {caseManagersContactDetails?.length === 1 && (
                                        <div className='flex'>
                                            <div className="relative pt-[34px]">
                                                <button className='clear_contact'
                                                    onClick={() => handleClearCaseManagerContact(index)}
                                                >
                                                    <span>
                                                        <img
                                                            loading='lazy'
                                                            decoding='async'
                                                            src="/images/red-x-line-icon.svg"
                                                            alt="clear-icon"
                                                            className='w-[27px]'
                                                        />
                                                    </span>
                                                </button>
                                                <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-9px] clear_contact_text opacity-0'>
                                                    Clear
                                                </p>
                                            </div>
                                            <div className='relative ml-4'>
                                                <button onClick={handleAddCaseContact} type='button' className='pt-[37px] add_contact'>
                                                    <span>
                                                        <img
                                                            loading='lazy'
                                                            decoding='async'
                                                            src="/images/add-plus-red.svg"
                                                            alt="add-icon"
                                                            id='add_more'
                                                        />
                                                    </span>
                                                </button>
                                                <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-10px] add_contact_text opacity-0'>
                                                    Add
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                    {caseManagersContactDetails?.length > 1 && (
                                        <>
                                            {index === 0 && (
                                                <div className="relative">
                                                    <button
                                                        onClick={() => {
                                                            setDeleteIndex(index);
                                                            handleRemoveCaseContact();
                                                        }}
                                                        className='pt-9 delete_contact'
                                                    >
                                                        <span>
                                                            <img
                                                                loading='lazy'
                                                                decoding='async'
                                                                src="/images/deleteicon-pink.svg"
                                                                alt="delete-icon"
                                                            />
                                                        </span>
                                                    </button>
                                                    <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                        Delete
                                                    </p>
                                                </div>
                                            )}
                                            {index !== 0 && index !== caseManagersContactDetails?.length - 1 && (
                                                <div className="relative">
                                                    <button
                                                        onClick={() => {
                                                            setDeleteIndex(index);
                                                            handleRemoveCaseContact();
                                                        }}
                                                        className='pt-9 delete_contact'
                                                    >
                                                        <span>
                                                            <img
                                                                loading='lazy'
                                                                decoding='async'
                                                                src="/images/deleteicon-pink.svg"
                                                                alt="delete-icon"
                                                            />
                                                        </span>
                                                    </button>
                                                    <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                        Delete
                                                    </p>
                                                </div>
                                            )}
                                            {index === caseManagersContactDetails?.length - 1 && (
                                                <div className='flex'>
                                                    <div className='relative'>
                                                        <button onClick={() => { setDeleteIndex(index); handleRemoveCaseContact() }} className='pt-9 delete_contact'>
                                                            <span>
                                                                <img
                                                                    loading='lazy'
                                                                    decoding='async'
                                                                    src="/images/deleteicon-pink.svg"
                                                                    alt="delete-icon"
                                                                />
                                                            </span>
                                                        </button>
                                                        <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[70px] left-[-15px] delete_contact_text opacity-0'>
                                                            Delete
                                                        </p>
                                                    </div>
                                                    <div className='relative ml-4'>
                                                        <button onClick={handleAddCaseContact} type='button' className='pt-[37px] add_contact'>
                                                            <span>
                                                                <img
                                                                    loading='lazy'
                                                                    decoding='async'
                                                                    src="/images/add-plus-red.svg"
                                                                    alt="add-icon"
                                                                    id='add_more'
                                                                />
                                                            </span>
                                                        </button>
                                                        <p className='bg-[#4B4B4B] px-1.5 text-sm font-normal text-white transition-all absolute top-[5px] left-[-10px] add_contact_text opacity-0'>
                                                            Add
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </Fragment>))}
                    </div>
                    <div>
                        <h1 className='border-b border-[#000000] pb-2 text-[18px] font-normal text-[#000000] relative basic_details_heading_dot mb-2.5'>Organizational Assignment and User Associations</h1>
                        <div className=''>
                            <div className='flex'>
                                <div className='lg:w-1/3 w-1/2 mr-2'>
                                    <SubdivisionDropdownWithSearch
                                        label={"Sub Division Name*"}
                                        placeholder={'Select sub division name'}
                                        id={'sub_division_name'}
                                        subdivisionData={suddivisonData}
                                        result={result}
                                        disabled={false}
                                        selectedSubdivisionName={selectedSubdivisionName}
                                        setisOpensub={setisOpensub}
                                        setQueryParams={setQueryParams}
                                        isOpensub={isOpensub}
                                        handleSelectionSubdivision={handleSelectionorgSubdivision}
                                        setSelectedOrganizationName={''}
                                        subdivisionloadingstatus={subdivisionStatus}
                                        isMonitor={true}
                                        emptyField={emptyField && selectedSubdivisionName.length === 0}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {confirmationState &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={""}
                                handleOnCLickActivate={handleFinalSubmit}
                                handleClose={handleConformationClick}
                                tittle={`${edit ? "Update" : "Add"} Patient`}
                                message={`Are you sure you want to ${edit ? "update" : "add"} this patient?`}
                                textMessage={true === false ? false : true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}
                                disabled={loading}
                            />
                        }
                    />
                }
                {confirmationStateCancel &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleCancel}
                                handleClose={handleConformationClickCancel}
                                tittle={'Cancel'}
                                message={`Are you sure you want to cancel ${edit ? "updating" : "adding"} this patient?`}
                                textMessage={true === false ? false : true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                disabled={loading}
                                CancelButton={'No'}
                            />
                        }
                    />
                }
                {confirmationDeleteCaseManagerDetails &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={deleteContactDetails}
                                handleClose={handelCloseDeleteModal}
                                tittle={'Delete'}
                                message={`Are you sure you want to delete this case manager contact details?`}
                                textMessage={true === false ? false : true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}
                                disabled={loading}
                            />
                        }
                    />
                }
                {confirmationDeleteEmergencyDetails &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={deleteEmergencyContactDetails}
                                handleClose={handelCloseDeleteEmeregencyModal}
                                tittle={'Delete'}
                                message={`Are you sure you want to delete this emergency contact details?`}
                                textMessage={true === false ? false : true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}
                                disabled={loading}
                            />
                        }
                    />
                }
                {confirmationStateStatus &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                disabled={loadingStatus}
                                loadingActivation={loadingStatus}
                                handleOnCLickActivate={handleOnCLickChangeStatus}
                                handleClose={handleConformationClickStatus}
                                tittle={statusToggle ? 'Activate' : 'Deactivate'}
                                message={`Are you sure you want to ${statusToggle ? 'activate' : 'deactivate'} this patient?`}
                                textMessage={statusToggle === false ? false : true}
                                buttonName={statusToggle ? 'Activate' : 'Deactivate'}
                            />
                        }
                    />
                }
            </div>
        </>
    )
}
